import { Flex, Icon, Spacing, Tooltip } from '@billy/design-system'
import type { ReactElement, ReactNode } from 'react'

interface InfoBoxBadgeLabelWithTooltipProps {
  label: ReactNode
  tooltipLabel: string
}

export const InfoBoxBadgeLabelWithTooltip = ({
  label,
  tooltipLabel,
}: InfoBoxBadgeLabelWithTooltipProps): ReactElement => {
  return (
    <Flex as="span" flexDirection="row" gap={Spacing.S6}>
      {label}
      <Tooltip as="span" label={tooltipLabel} placement="top">
        <Icon icon="circleQuestionMark" size="xs" />
      </Tooltip>
    </Flex>
  )
}
